module.exports = __webpack_public_path__ + "img/dateTop.18ac1d2d.png";